<template>
  <div class="bootcamp-tile-results">
    <BootcampResults
      :items="notPast"
      @child-element-render="handleRememberPosition"
    />
    <div class="bootcamp-tile-results__past-wrapper" v-if="past && past.length">
      <h3 class="bootcamp-tile-results__title">
        Passed Bootcamps
      </h3>
      <div class="bootcamp-tile-results__past">
        <div v-for="item in past" :key="item.objectID">
          <Tile
            :background="`${item.background_image_url}`"
            :item="item"
            :isFreeTrialUser="isFreeTrialUser"
            :link="$buildContentLink('bootcamp', item)"
            :learningArea="getLearningArea(item)"
            :learningAreaColor="getLearningAreaColor(item)"
            :showHeader="true"
            :displayDuration="true"
            :showAddedDate="true"
            @element-rend="handleRememberPosition"
          ></Tile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { compareAsc } from 'date-fns'
import { getLearningArea, getLearningAreaColor } from '@/helpers'
import Tile from '@/components/layout/Tile.vue'
import BootcampResults from '@/components/search/BootcampResults.vue'

const marked = require('marked')

export default {
  name: 'BootcampListResults',
  components: {
    BootcampResults,
    Tile,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    // should be all the bootcamps, no pagination in favor of grouping
    items: {
      type: Array,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    notPast() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.end_datetime * 1000), new Date()) >= 0
      })
    },
    past() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.end_datetime * 1000), new Date()) <= 0
      })
    },
  },
  methods: {
    handleRememberPosition(elId) {
      this.$emit('element-render', elId)
    },
  },
}
</script>

<style lang="scss" scoped>
.bootcamp-tile-results {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  &__title {
    color: var(--white);
    font-size: rem(20px);
    font-weight: bold;
    margin: 0;
    width: 100%;
  }
  &__past {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    width: 100%;
    flex-grow: 1;

    @include tablet {
      grid-template-columns: repeat(2, 1fr);
    }
    @include desktop {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 8px;
    }

    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
  &__past-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 15px;
  }
}
</style>
